import { useEffect, useState } from "react";

const KEY = "tipomatic.adConsent";
const EVENT = "tipomatic:ad-consent-change";

export type ConsentState = "granted" | "denied" | "unknown";

export function getStoredConsent(): ConsentState {
  if (typeof window === "undefined") return "unknown";
  const v = localStorage.getItem(KEY);
  if (v === "granted" || v === "denied") return v;
  return "unknown";
}

export function setConsent(value: "granted" | "denied") {
  localStorage.setItem(KEY, value);
  window.__adsenseConsent = value;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
}

export function useAdConsent(): ConsentState {
  const [state, setState] = useState<ConsentState>(() => getStoredConsent());
  useEffect(() => {
    const handler = () => setState(getStoredConsent());
    window.addEventListener(EVENT, handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener(EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);
  return state;
}
